var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 423,
    height: 896,
    viewBox: "0 0 423 896",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    width: 417,
    height: 896,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 0V382.053C3 382.053 35.2351 450.788 118.112 442.811C200.989 434.835 218.177 391.876 318.243 471.049C318.243 471.049 353.543 504.185 418 502.967V0H3Z",
    fill: "#FAF8F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 0V382.053C3 382.053 35.2351 450.788 118.112 442.811C200.989 434.835 218.177 391.876 318.243 471.049C318.243 471.049 353.543 504.185 418 502.967V0H3Z",
    fill: "#FAF8F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgImg);
export default __webpack_public_path__ + "static/media/bgImg.d6bb3c8b12533a7289abc7d8fe8e9313.svg";
export { ForwardRef as ReactComponent };